// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import I18next from "i18next";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Js_promise from "rescript/lib/es6/js_promise.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactI18next from "react-i18next";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";
import * as Utils_Shared$LiveRoom from "../src/client/Utils/Utils_Shared.bs.js";
import * as TranslationVariants$LiveRoom from "../src/client/TranslationVariants.bs.js";

function keyToJs(param) {
  return param;
}

var LanguageSessionStorage = Utils_Shared$LiveRoom.Web.MakeSessionStorage({
      keyToJs: keyToJs,
      keys: {
        hd: "language",
        tl: /* [] */0
      }
    });

function storeLanguageInSession(language) {
  Curry._2(LanguageSessionStorage.setItem, "language", language);
}

function checkLanguageInSession(param) {
  return Curry._1(LanguageSessionStorage.getItem, "language");
}

var _map = {"En":"en","Is":"is","Fr":"fr","ZhHant":"zh-Hant","ZhHans":"zh-Hans","It":"it","De":"de"};

var _revMap = {"en":"En","is":"Is","fr":"Fr","zh-Hant":"ZhHant","zh-Hans":"ZhHans","it":"It","de":"De"};

function languageToJs(param) {
  return _map[param];
}

function languageFromJs(param) {
  return _revMap[param];
}

var StringNotFound = /* @__PURE__ */Caml_exceptions.create("Translations-LiveRoom.StringNotFound");

function getAllQueryParams(param) {
  var query = window.location.search;
  var _queryParams = Belt_List.flatten(Belt_List.fromArray(Belt_Array.map(Js_string.split("&", Js_string.concatMany(Js_string.split("?", query), "")), (function (str) {
                  return Belt_List.fromArray(Js_string.split("=", str));
                }))));
  var _jointParams = /* [] */0;
  while(true) {
    var jointParams = _jointParams;
    var queryParams = _queryParams;
    if (!queryParams) {
      return jointParams;
    }
    var match = queryParams.tl;
    var name = queryParams.hd;
    if (!match) {
      return Belt_List.setAssoc(jointParams, name, "", (function (prim0, prim1) {
                    return prim0 === prim1;
                  }));
    }
    var rest = match.tl;
    var value = match.hd;
    if (!rest) {
      return Belt_List.setAssoc(jointParams, name, value, (function (prim0, prim1) {
                    return prim0 === prim1;
                  }));
    }
    _jointParams = Belt_List.setAssoc(jointParams, name, value, (function (prim0, prim1) {
            return prim0 === prim1;
          }));
    _queryParams = rest;
    continue ;
  };
}

var language = {
  contents: "En"
};

function setLanguage(newLang) {
  language.contents = newLang;
}

function getLanguage(param) {
  return language.contents;
}

function getCatalogingLanguage(param) {
  var match = language.contents;
  if (match === "Fr") {
    return "FRENCH";
  } else if (match === "ZhHans") {
    return "CHINESE_SIMPLIFIED";
  } else if (match === "ZhHant") {
    return "CHINESE_TRADITIONAL";
  } else {
    return "ENGLISH";
  }
}

function setupLanguage(param) {
  var languageFromSession = Belt_Option.getWithDefault(Curry._1(LanguageSessionStorage.getItem, "language"), "en");
  var language$1 = Belt_Option.getWithDefault(languageFromJs(Belt_Option.getWithDefault(Belt_List.getAssoc(getAllQueryParams(undefined), "locale", (function (prim0, prim1) {
                      return prim0 === prim1;
                    })), languageFromSession)), "En");
  language.contents = language$1;
  var language$2 = languageToJs(language$1);
  Curry._2(LanguageSessionStorage.setItem, "language", language$2);
}

var english = (require('./en/live-room.json'));

var icelandic = (require('./is-IS/live-room.json'));

var french = (require('./fr-FR/live-room.json'));

var chineseTraditional = (require('./zh-TW/live-room.json'));

var chineseSimplified = (require('./zh-CN/live-room.json'));

function getLanguageStrings(lang) {
  if (lang === "Fr") {
    return french;
  } else if (lang === "Is") {
    return icelandic;
  } else if (lang === "ZhHans") {
    return chineseSimplified;
  } else if (lang === "ZhHant") {
    return chineseTraditional;
  } else {
    return english;
  }
}

function getTranslation(_langOpt, string) {
  while(true) {
    var langOpt = _langOpt;
    var lang = langOpt !== undefined ? langOpt : language.contents;
    var match = Js_dict.get(getLanguageStrings(lang), string);
    if (match !== undefined) {
      return match;
    }
    if (lang === "En") {
      console.error("String " + string + " not found, please run in your terminal yarn extract\n     ");
      throw {
            RE_EXN_ID: StringNotFound,
            Error: new Error()
          };
    }
    console.error("Translation not found for " + (string + (" in language" + languageToJs(lang))));
    _langOpt = "En";
    continue ;
  };
}

function replaceVariablesInString(string, variables) {
  return Belt_Array.reduce(variables, string, (function (newString, param) {
                return Js_string.replace(param[0], param[1], newString);
              }));
}

var i18n = I18next;

var languageFromQueryParam = Belt_Option.getWithDefault(Belt_List.getAssoc(getAllQueryParams(undefined), "locale", (function (prim0, prim1) {
            return prim0 === prim1;
          })), "en");

Js_promise.then_((function (_t) {
        return Promise.resolve(undefined);
      }), i18n.use(ReactI18next.initReactI18next).init({
          lng: languageFromQueryParam,
          ns: ["live-room"],
          defaultNS: ["live-room"],
          debug: false,
          resources: {
            en: {
              "live-room": (require("./en/live-room.json"))
            },
            fr: {
              "live-room": (require("./fr-FR/live-room.json"))
            },
            "zh-Hant": {
              "live-room": (require("./zh-TW/live-room.json"))
            },
            "zh-Hans": {
              "live-room": (require("./zh-CN/live-room.json"))
            }
          },
          interpolation: {
            escapeValue: false
          }
        }));

function t(translationVariant) {
  return i18n.t(TranslationVariants$LiveRoom.tToJs(translationVariant));
}

function t2(translationVariant, tValues) {
  return i18n.t(TranslationVariants$LiveRoom.tToJs(translationVariant), tValues);
}

export {
  LanguageSessionStorage ,
  storeLanguageInSession ,
  checkLanguageInSession ,
  languageToJs ,
  languageFromJs ,
  StringNotFound ,
  getAllQueryParams ,
  language ,
  setLanguage ,
  getLanguage ,
  getCatalogingLanguage ,
  setupLanguage ,
  english ,
  icelandic ,
  french ,
  chineseTraditional ,
  chineseSimplified ,
  getLanguageStrings ,
  getTranslation ,
  replaceVariablesInString ,
  i18n ,
  languageFromQueryParam ,
  t ,
  t2 ,
}
/* LanguageSessionStorage Not a pure module */
